import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

const IconTouchArea = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  width: ${px2rem(128)};
  height: ${px2rem(128)};
  margin: ${px2rem(-64)} 0 0 ${px2rem(-64)};

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: ${px2rem(64)};
    height: ${px2rem(64)};
    z-index: 1;
    fill: rgba(255, 255, 255, 0.9);
  }
`;

export default IconTouchArea;
